import { CustomerProduct, PrepaidProductStatus } from 'types';
import { baseQuery } from '../baseQuery';

type PutCustomerProductsParams = {
  customerId?: number;
  customerProductId: number;
  name?: string;
  status?: PrepaidProductStatus;
};

export const putCustomerProduct = async ({ customerProductId, customerId, status }: PutCustomerProductsParams) => {
  const params = new URLSearchParams();

  // set required param for `customer_product_id`
  params.set('customer_product_id', customerProductId.toString());

  // set optional params for new_customer_id and status if passed
  if (customerId) params.set('new_customer_id', customerId.toString());
  if (status) params.set('status', status);

  const { data } = await baseQuery(`customer-products?${params}`, { type: 'PUT' });

  return data as CustomerProduct[];
};
